/**
 * Kadmin Dark Theme — Colors
 */

const colors = {
  mode: "dark",

  background: {
    default: "#0F1114",
    sidenav: "#161B1F",
    card: "#1A1F23",
    paper: "#21262B",
    glass: "rgba(255, 255, 255, 0.03)",
    glassBorder: "rgba(255, 255, 255, 0.08)",
    cardInner: "rgba(255, 255, 255, 0.03)",
  },

  text: {
    main: "rgba(255, 255, 255, 0.87)",
    focus: "rgba(255, 255, 255, 0.87)",
    secondary: "rgba(255, 255, 255, 0.6)",
    disabled: "rgba(255, 255, 255, 0.38)",
  },

  transparent: { main: "rgba(0, 0, 0, 0)" },
  white: { main: "#ffffff", focus: "#ffffff" },
  black: { light: "#000000", main: "#000000", focus: "#000000" },

  primary: { light: "#5EEAD4", main: "#14B8A6", dark: "#0D9488", focus: "#2DD4BF" },
  secondary: { light: "#94A3B8", main: "#64748B", dark: "#475569", focus: "#94A3B8" },
  info: { light: "#60A5FA", main: "#3B82F6", dark: "#2563EB", focus: "#60A5FA" },
  success: { light: "#34D399", main: "#10B981", dark: "#059669", focus: "#34D399" },
  warning: { light: "#FBBF24", main: "#F59E0B", dark: "#D97706", focus: "#FBBF24" },
  error: { light: "#F87171", main: "#EF4444", dark: "#DC2626", focus: "#F87171" },

  light: { main: "#1A1F23", focus: "#262C31" },
  dark: { main: "#E2E8F0", focus: "#F1F5F9" },

  grey: {
    100: "#1A1F23",
    200: "#262C31",
    300: "#343B41",
    400: "#64748B",
    500: "#94A3B8",
    600: "#CBD5E1",
    700: "#E2E8F0",
    800: "#F1F5F9",
    900: "#F8FAFC",
  },

  gradients: {
    primary: { main: "#5EEAD4", state: "#14B8A6" },
    secondary: { main: "#94A3B8", state: "#475569" },
    info: { main: "#60A5FA", state: "#3B82F6" },
    success: { main: "#34D399", state: "#10B981" },
    warning: { main: "#FBBF24", state: "#F59E0B" },
    error: { main: "#F87171", state: "#EF4444" },
    light: { main: "#1A1F23", state: "#262C31" },
    dark: { main: "#CBD5E1", state: "#F1F5F9" },
  },

  socialMediaColors: {
    facebook: { main: "#1877F2", dark: "#166FE5" },
    twitter: { main: "#1DA1F2", dark: "#1A91DA" },
    github: { main: "#ffffff", dark: "#e0e0e0" },
  },

  badgeColors: {
    primary: { background: "rgba(13, 148, 136, 0.15)", text: "#5EEAD4" },
    secondary: { background: "rgba(148, 163, 184, 0.15)", text: "#94A3B8" },
    info: { background: "rgba(59, 130, 246, 0.15)", text: "#60A5FA" },
    success: { background: "rgba(16, 185, 129, 0.15)", text: "#34D399" },
    warning: { background: "rgba(245, 158, 11, 0.15)", text: "#FBBF24" },
    error: { background: "rgba(239, 68, 68, 0.15)", text: "#F87171" },
  },

  coloredShadows: {
    primary: "#14B8A6",
    secondary: "#475569",
    info: "#3B82F6",
    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444",
    light: "#1A1F23",
    dark: "#000000",
  },

  inputBorderColor: "#343B41",
  inputBorderHoverColor: "rgba(255, 255, 255, 0.3)",
  divider: "#262C31",
  tabs: { indicator: { boxShadow: "#343B41" } },

  headerOverlay: {
    button: "rgba(255, 255, 255, 0.15)",
    buttonHover: "rgba(255, 255, 255, 0.25)",
    icon: "rgba(255, 255, 255, 0.1)",
    iconHover: "rgba(255, 255, 255, 0.2)",
    chip: "rgba(255, 255, 255, 0.2)",
  },
};

export default colors;
